import { useMemo } from 'react';
import i18n from 'i18n';
import { statusOptions } from 'helpers/constants';
import { SHOW_ALL_OPTION } from '../../constants';

export const useServiceStatuses = (showAll = true) => {
  const serviceStatuses = useMemo(() => {
    // Use the statusOptions from constants and keep original character IDs
    const statuses = statusOptions().map((status) => ({
      id: status.id, // Use original character ID (X, C, P, etc.)
      name: status.name,
      groupBy: status.groupBy,
      statusType: status.groupBy === "Complete" ? "C" : "O"
    }));

    // Add group header options so they can be found during initialization.
    // No `groupBy` here on purpose: these live in the dropdown dataSource for
    // id-based lookup only and must NOT render as list items under a group.
    // `name` is translated at access time via a getter (i18n may not be ready
    // at module load, and the label must react to language changes).
    const groupOptions = [
      { id: 1, statusType: "C", get name() { return i18n.t("action.complete"); } },
      { id: 2, statusType: "O", get name() { return i18n.t("label.notComplete"); } }
    ];

    // Combine all options: Show All + Group Headers + Individual Statuses
    const allOptions = showAll ? [SHOW_ALL_OPTION, ...groupOptions, ...statuses] : [...groupOptions, ...statuses];

    return allOptions;
  }, [showAll]);

  return serviceStatuses;
};

// Export group members for external use.
// `groupBy` is the STABLE identifier matched against each status's `groupBy`
// value for grouping; `name` is translated for display only.
export const GROUP_MEMBERS = [
  { id: 1, statusType: "C", groupBy: "Complete", get name() { return i18n.t("action.complete"); } },
  { id: 2, statusType: "O", groupBy: "Not Complete", get name() { return i18n.t("label.notComplete"); } }
];
